module.exports = __webpack_public_path__ + "img/qa.cd4ff8c2.svg";